import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { CoverageReportAction } from '../../coverageReport.action';

export const CoverageReportListSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(CoverageReportAction.loadList.started());
  }, [dispatch]);

  return null;
};
